// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"065a5175","291":"f2fe1944","337":"50b86d95","361":"6291311f","381":"ff429235","437":"544717bd","461":"177d2807","465":"3b5b19e1","494":"8c2bf550","503":"448b7c51","571":"d9375fc2","610":"16aa25ef","763":"549ad00b","791":"7c73ab92","842":"438ce6a9"}[chunkId] + ".chunk.js";
};